/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GlobalPaymentsButton_configuration = {
    readonly currency: string;
    readonly organisationContact: string;
    readonly " $refType": "GlobalPaymentsButton_configuration";
};
export type GlobalPaymentsButton_configuration$data = GlobalPaymentsButton_configuration;
export type GlobalPaymentsButton_configuration$key = {
    readonly " $data"?: GlobalPaymentsButton_configuration$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GlobalPaymentsButton_configuration">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalPaymentsButton_configuration",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationContact",
            "storageKey": null
        }
    ],
    "type": "Configuration",
    "abstractKey": null
} as any;
(node as any).hash = '246b0b474f997fe6d448a15a8411a01f';
export default node;
